<template>
  <div class="uk-container">
    <form>
      <fieldset class="uk-fieldset">
        <h3 class="uk-margin-remove-bottom">Handle</h3>
        <p class="uk-margin-small uk-margin-remove-top">
          This should match the "handle" field from the product on Shopify
          exactly, without the product type. For example, if the handle for the
          necktie version of the product is "bruce-stripe-necktie", the handle
          should be "bruce-stripe"
        </p>
        <div class="uk-margin">
          <input
            v-model="patternData.handle"
            class="uk-input"
            type="text"
            placeholder="Handle"
          />
        </div>
        <h3 class="uk-margin-remove-bottom">Select Files</h3>
        <p v-if="fileNames.necktie">Necktie: {{ fileNames.necktie }}</p>
        <p v-if="fileNames['bow-tie']">Bow Tie: {{ fileNames["bow-tie"] }}</p>
        <p v-if="fileNames['pocket-square']">
          Pocket Square: {{ fileNames["pocket-square"] }}
        </p>
        <p v-if="fileNames['robe']">Robe: {{ fileNames["robe"] }}</p>
        <p v-if="fileNames['face-mask']">
          Face Mask: {{ fileNames["face-mask"] }}
        </p>
        <p v-if="fileNames['table-runner']">
          Table Runner: {{ fileNames["table-runner"] }}
        </p>
        <p v-if="fileNames['square-pillow']">
          Square Pillow: {{ fileNames["square-pillow"] }}
        </p>
        <p v-if="fileNames['lumbar-pillow']">
          Lumbar Pillow: {{ fileNames["lumbar-pillow"] }}
        </p>
        <p v-if="fileNames['suspenders']">
          Suspenders: {{ fileNames["suspenders"] }}
        </p>
        <p v-if="fileNames['hair-scarf']">
          Hair Scarf: {{ fileNames["hair-scarf"] }}
        </p>
        <div v-if="finished">
          <p>Upload Complete</p>
        </div>
        <div class="uk-margin">
          <div class="js-upload" uk-form-custom>
            <input type="file" @change="fileSelected" />
            <button
              class="uk-button uk-button-default"
              type="button"
              tabindex="-1"
            >
              Select File
            </button>
          </div>
        </div>
      </fieldset>
    </form>
    <button v-on:click="prepareSvgs()" class="uk-button uk-button-primary">
      Submit
    </button>
  </div>
</template>

<script>
import ProductsService from "@/services/ProductsService";
import UIkit from "uikit";

export default {
  name: "PatternUpload",
  data() {
    return {
      patternData: {
        svg: {
          necktie: "",
          "bow-tie": "",
          "pocket-square": "",
          "face-mask": "",
          "table-runner": "",
          robe: "",
          "square-pillow": "",
          "lumbar-pillow": "",
          "hair-scarf": "",
          suspenders: ""
        },
        handle: "",
        colorCount: null
      },
      fileNames: {
        necktie: "",
        "bow-tie": "",
        "pocket-square": "",
        "face-mask": "",
        "table-runner": "",
        robe: "",
        "square-pillow": "",
        "lumbar-pillow": "",
        "hair-scarf": "",
        suspenders: ""
      },
      finished: false
    };
  },
  methods: {
    fileSelected(event) {
      var self = this;
      for (let index = 0; index < event.target.files.length; index++) {
        const element = event.target.files[index];
        const file = event.target.files[0];
        console.log(file);
        if (file.name.includes("pocket")) {
          self.fileNames["pocket-square"] = file.name;
          const reader = new FileReader();
          reader.readAsText(file);
          reader.onload = e =>
            (self.patternData.svg["pocket-square"] = e.target.result);
        } else if (file.name.includes("bow")) {
          self.fileNames["bow-tie"] = file.name;
          const reader = new FileReader();
          reader.readAsText(file);
          reader.onload = e =>
            (self.patternData.svg["bow-tie"] = e.target.result);
        } else if (file.name.includes("neck")) {
          self.fileNames["necktie"] = file.name;
          const reader = new FileReader();
          reader.readAsText(file);
          reader.onload = e => (self.patternData.svg.necktie = e.target.result);
        } else if (file.name.includes("mask")) {
          self.fileNames["face-mask"] = file.name;
          const reader = new FileReader();
          reader.readAsText(file);
          reader.onload = e =>
            (self.patternData.svg["face-mask"] = e.target.result);
        } else if (file.name.includes("table")) {
          self.fileNames["table-runner"] = file.name;
          const reader = new FileReader();
          reader.readAsText(file);
          reader.onload = e =>
            (self.patternData.svg["table-runner"] = e.target.result);
        } else if (file.name.includes("robe")) {
          self.fileNames["robe"] = file.name;
          const reader = new FileReader();
          reader.readAsText(file);
          reader.onload = e => (self.patternData.svg["robe"] = e.target.result);
        } else if (file.name.includes("square-pillow")) {
          self.fileNames["square-pillow"] = file.name;
          const reader = new FileReader();
          reader.readAsText(file);
          reader.onload = e =>
            (self.patternData.svg["square-pillow"] = e.target.result);
        } else if (file.name.includes("lumbar-pillow")) {
          self.fileNames["lumbar-pillow"] = file.name;
          const reader = new FileReader();
          reader.readAsText(file);
          reader.onload = e =>
            (self.patternData.svg["lumbar-pillow"] = e.target.result);
        } else if (file.name.includes("suspenders")) {
          self.fileNames["suspenders"] = file.name;
          const reader = new FileReader();
          reader.readAsText(file);
          reader.onload = e =>
            (self.patternData.svg["suspenders"] = e.target.result);
        } else if (file.name.includes("hair-scarf")) {
          self.fileNames["hair-scarf"] = file.name;
          const reader = new FileReader();
          reader.readAsText(file);
          reader.onload = e =>
            (self.patternData.svg["hair-scarf"] = e.target.result);
        }
      }

      //self.patternData.svg["pocket-square"] = reader.readAsText(file);
    },
    prepareSvgs() {
      var self = this;
      var svgObj = self.patternData.svg;
      for (var prop in svgObj) {
        var svg = svgObj[prop];
        var product = prop;
        if (svg) {
          var colorEdited = svg
            .replace("<style", "<svg:style")
            .replace("</style", "</svg:style")
            .replace("#111", "{{colors[0]}}")
            .replace("#111", "{{colors[0]}}")
            .replace("#111", "{{colors[0]}}")
            .replace("#222", "{{colors[1]}}")
            .replace("#222", "{{colors[1]}}")
            .replace("#222", "{{colors[1]}}")
            .replace("#333", "{{colors[2]}}")
            .replace("#333", "{{colors[2]}}")
            .replace("#333", "{{colors[2]}}")
            .replace("#444", "{{colors[3]}}")
            .replace("#444", "{{colors[3]}}")
            .replace("#444", "{{colors[3]}}")
            .replace("#555", "{{colors[4]}}")
            .replace("#555", "{{colors[4]}}")
            .replace("#555", "{{colors[4]}}")
            .replace("#666", "{{colors[5]}}")
            .replace("#666", "{{colors[5]}}")
            .replace("#666", "{{colors[5]}}")
            .replace(/"/g, '"');
          var idEdited =
            colorEdited.substr(0, 5) +
            "id='svgPreview' " +
            colorEdited.substr(5);
          self.patternData.svg[product] = idEdited;
        }
      }
      if (colorEdited.includes("colors[5]")) {
        self.patternData.colorCount = 6;
      } else if (colorEdited.includes("colors[4]")) {
        self.patternData.colorCount = 5;
      } else if (colorEdited.includes("colors[3]")) {
        self.patternData.colorCount = 4;
      } else if (colorEdited.includes("colors[2]")) {
        self.patternData.colorCount = 3;
      } else if (colorEdited.includes("colors[1]")) {
        self.patternData.colorCount = 2;
      } else if (colorEdited.includes("colors[0]")) {
        self.patternData.colorCount = 1;
      }
      console.log(this.patternData);
      this.addProductGroup();
    },
    async addProductGroup() {
      let self = this;
      var response = await ProductsService.addProductGroup({
        patternData: this.patternData
      });

      if (response.data) {
        console.log(response);
        self.finished = response.status;
      }
    }
  },
  mounted: function() {
    console.log(this.patternData);
  }
};
</script>

<style type="text/css"></style>



// WEBPACK FOOTER //
// src/components/PatternUpload.vue